import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '../components/ui/SectionHeading';

const Insights = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://zvpxmxcznimhwhxjnhvn.supabase.co';
        const ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'YOUR_PUBLIC_ANON_KEY';
        const WORKSPACE_ID = import.meta.env.VITE_WORKSPACE_ID || '1443c1b6-cab0-4cdd-867b-38987695815c';

        const response = await fetch(`${SUPABASE_URL}/rest/v1/blog_posts?workspace_id=eq.${WORKSPACE_ID}&status=eq.published&order=published_at.desc`, {
          headers: {
            'apikey': ANON_KEY,
            'Authorization': `Bearer ${ANON_KEY}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch blog posts');
        }

        const data = await response.json();
        setPosts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <div className="pt-24 min-h-screen bg-slate-50 dark:bg-brand-dark transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <SectionHeading title="The Tool Trap™" subtitle="Diagnosing marketing's most expensive mistake" className="relative z-10" />

        {loading && (
          <div className="text-center py-12">
            <p className="text-slate-600 dark:text-slate-400 text-lg">Loading insights...</p>
          </div>
        )}

        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 text-brand-red dark:text-red-400 p-6 rounded-xl text-center border border-red-200 dark:border-red-800/30">
            <p>Error loading posts: {error}</p>
          </div>
        )}

        {!loading && !error && posts.length === 0 && (
          <div className="bg-white dark:bg-slate-900 p-8 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 text-center">
            <h2 className="text-2xl font-bold text-brand-dark dark:text-white mb-4">SEVEN HATS® Blog Integration</h2>
            <p className="text-slate-600 dark:text-slate-400">
              No published posts found. This space is prepared for the SEVEN HATS® platform blog post generator tool.
            </p>
          </div>
        )}

        {!loading && !error && posts.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map(post => (
              <Link to={`/insights/${post.slug}`} key={post.id} className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 overflow-hidden flex flex-col transition-transform hover:-translate-y-1 hover:shadow-2xl">
                {post.image && (
                  <div className="w-full h-48 overflow-hidden">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                  </div>
                )}
                <div className="p-6 flex-grow flex flex-col">
                  <div className="text-sm text-slate-500 dark:text-slate-400 mb-3">
                    {new Date(post.published_at).toLocaleDateString('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </div>
                  <h3 className="text-xl font-bold text-brand-dark dark:text-white mb-3 line-clamp-2 group-hover:text-brand-red dark:group-hover:text-brand-cyan transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-300 mb-6 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="mt-auto pt-4 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between">
                    <span className="text-brand-red dark:text-brand-cyan font-medium text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                      Read more <span className="text-lg">→</span>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Insights;
